import { createAsyncThunk } from '@reduxjs/toolkit';

import { CareerPathResponse, CareerCategory, CareerPath, Industry } from '@backrs_ui/common-ui';

import {
  CareerPathRole,
  CareerPathMeaning,
  CareerPathEnjoyment,
} from '@backrs_ui/grow-ui/src/models/models';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

/** What we expect from the BE */
export type CareerPathContentResponse = Readonly<{
  careerCategories: CareerCategory[];
  careerPaths: CareerPathResponse[];
  careerPathRoles: CareerPathRole[];
  careerPathMeanings: CareerPathMeaning[];
  careerPathEnjoyments: CareerPathEnjoyment[];
  industries: Industry[];
}>;

export const fetchCareerPathsAndRoles = createAsyncThunk(
  'careerPath/fetchCarerPaths',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${ENVIRONMENT_URL}/career-path`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as CareerPathContentResponse;
    } catch (error) {
      return rejectWithValue(`Failed to fetch career questions with error: ${error}`);
    }
  },
);

export function mapCareerPathResponseToCareerPath(response: CareerPathResponse[]): CareerPath[] {
  return response.map((path) => ({
    id: path.id,
    career_category_id: path.career_category_id,
    name: path.name,
    description: path.description,
    insight: path.insight,
    early_career_hires_per_year: {
      skilled_technical: path.early_career_hires_per_year_skilled_technical,
      professional: path.early_career_hires_per_year_professional,
    },
    growth: path.growth,
    ai_disruption: path.ai_disruption,
    career_track_distribution: {
      SEMISKILLED: path.career_track_distribution_semi_skilled,
      TRADE: path.career_track_distribution_trade,
      MID: path.career_track_distribution_mid,
      UPPER: path.career_track_distribution_upper,
      TOP: path.career_track_distribution_top,
    },
    askLubavButtonResponse: path.askLubavButtonResponse,
  }));
}
